import { render, staticRenderFns } from "./AssetChangeList.vue?vue&type=template&id=1600fa64"
import script from "./AssetChangeList.vue?vue&type=script&lang=js"
export * from "./AssetChangeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1600fa64')) {
      api.createRecord('1600fa64', component.options)
    } else {
      api.reload('1600fa64', component.options)
    }
    module.hot.accept("./AssetChangeList.vue?vue&type=template&id=1600fa64", function () {
      api.rerender('1600fa64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/fixed-asset/AssetChangeList.vue"
export default component.exports